import React from "react";
import {
  Card,
  CardBody,
  Box,
  Heading,
  Text,
  Stack,
  StackDivider,
} from "@chakra-ui/react";
import moment from "moment";

export default function EventCard({ data = {} }) {
  const { eventName, date, startTime, endTime, postedOn } = data;
  return (
    <Card cursor="pointer" mb={4}>
      <CardBody>
        <Stack divider={<StackDivider />} spacing="2">
          <Box>
            <Heading size="xs" textTransform="uppercase">
              {eventName}
            </Heading>
          </Box>
          <Box>
            <Text fontSize="sm" textTransform="uppercase" color="gray.500">
              Tanggal & Waktu
            </Text>
            <Text pt={1} fontSize={12}>
              {moment(date).format("dddd, DD MMMM YYYY")}
              {" | "}
              {`${startTime} - ${endTime}`}
            </Text>
            {postedOn && (
              <Text pt="3" fontSize="xs" color="gray.500">
                Posted on: {moment(postedOn).format("DD MMMM YYYY")}
              </Text>
            )}
          </Box>
        </Stack>
      </CardBody>
    </Card>
  );
}
